import { useIntl } from 'react-intl'

import ItemTypeAndBookedLabel from '../Common/ItemTypeAndBookedLabel'
import StartAndEndLocation from '../Common/StartAndEndLocation'
import SummaryAdditionalNotes from '../Common/SummaryAdditionalNotes'

import FormatCurrency from 'components/Common/FormatCurrency'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import ModalContent from 'LuxKit/Modal/ModalContent'
import TextLink from 'LuxKit/TextLink'
import BodyText from 'LuxKit/Typography/BodyText'
import AddressWithViewMapButton from 'tripPlanner/components/TripModal/TripItems/Summary/Common/AddressWithViewMapButton'
import CheckInAndOutDate from 'tripPlanner/components/TripModal/TripItems/Summary/Common/CheckInAndOutDate'
import type { CruiseItem, TourItem } from 'tripPlanner/types/tripItem'

type Props = {
  item: CruiseItem | TourItem
}

function CustomItemSummaryContent({ item }: Props) {
  const intl = useIntl()
  const showDates =
    item.endDate || item.startDate || item.startDay || item.endDay
  const isPickAndDropTheSame =
    item.startPlace.address === item.endPlace?.address

  return (
    <ModalContent>
      <VerticalSpacer gap={20}>
        <ItemTypeAndBookedLabel item={item} />
        {showDates && (
          <CheckInAndOutDate
            isAccommodation={false}
            startDate={item.startDate}
            endDate={item.endDate}
            startTime={item.startTime}
            endTime={item.endTime}
          />
        )}
        {isPickAndDropTheSame && item.startPlace.address && (
          <AddressWithViewMapButton
            item={item}
            address={item.startPlace.address}
          />
        )}
        {!isPickAndDropTheSame && (
          <StartAndEndLocation
            startPlace={item.startPlace}
            endPlace={item.endPlace}
          />
        )}
        {item.url && (
          <div>
            <BodyText variant="small" weight="bold">
              {intl.formatMessage({
                id: '_jrveeRjrZwuUBQfvTIA',
                defaultMessage: 'Website',
                description: 'Form field label for website URL in custom trip item summary',
              })}
            </BodyText>
            <TextLink href={item.url} target="_blank" rel="nofollow">
              {item.url}
            </TextLink>
          </div>
        )}
        {item.price && (
          <div>
            <BodyText variant="small" weight="bold">
              {intl.formatMessage({
                id: 'CyIrMvh7gJ1Vh0gHswMj',
                defaultMessage: 'Price',
                description: 'Label for price in custom trip item summary in the trip planner',
              })}
            </BodyText>
            <BodyText variant="large">
              <FormatCurrency value={item.price} />
            </BodyText>
          </div>
        )}
        {item.confirmationCode && (
          <div>
            <BodyText variant="small" weight="bold">
              {intl.formatMessage({
                id: 'h1aFI9TOdPBOk4ivoODa',
                defaultMessage: 'Confirmation number',
                description: 'Label for booking confirmation number in custom trip item summary',
              })}
            </BodyText>
            <BodyText variant="large">{item.confirmationCode}</BodyText>
          </div>
        )}
        {item.notes && <SummaryAdditionalNotes notes={item.notes} />}
      </VerticalSpacer>
    </ModalContent>
  )
}

export default CustomItemSummaryContent
